import styled from 'styled-components';

import { TranslatableText, useTranslate } from '@dreryk/react-common';
import { fonts, Tooltip } from '@dreryk/react-components';

const StyledMedicineRawMaterialTableHeader = styled.div`
   font-weight: ${fonts.fontWeightBold};
`;

StyledMedicineRawMaterialTableHeader.displayName = 'StyledMedicineRawMaterialTableHeader';

type MedicineRawMaterialTableHeaderProps = {
   readonly label: TranslatableText;
};

const MedicineRawMaterialTableHeader = (props: MedicineRawMaterialTableHeaderProps): JSX.Element => {
   const translate = useTranslate();

   return <StyledMedicineRawMaterialTableHeader>{translate(props.label)}</StyledMedicineRawMaterialTableHeader>;
};

export const createMedicineRawMaterialTableHeaderWithTooltip = (
   label: TranslatableText,
   tooltipText: TranslatableText
) => {
   return (): JSX.Element => {
      return (
         <Tooltip content={tooltipText} testId={'tooltip'}>
            <MedicineRawMaterialTableHeader label={label} />
         </Tooltip>
      );
   };
};
